"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpcomingDeparture = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
class UpcomingDeparture extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.departureDate)
            && utils_1.Guard.isNotNullish(this.returnDate));
    }
    toPlain() {
        return { ...this };
    }
}
exports.UpcomingDeparture = UpcomingDeparture;
//# sourceMappingURL=UpcomingDeparture.js.map